//#region [IMPORT]

// === THIRD-PARTY
import React, {useContext} from 'react';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// === CSS ===
import './index.css';

// === COMPONENTS ===
import { ServerPanel } from './ServerPanel';
import { UsersPanel } from './UsersPanel';
import { RolesPanel } from './RolesPanel';
import { ModulesPanel } from './ModulesPanel';
import { AppContext } from 'pages/App/components/AppContext/AppContext';

//#endregion

//-----------------------------------------------------------------
export function Admin() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { user_details } = useContext( AppContext );

  const theme        = useTheme();
  const navigate     = useNavigate();

  const hasPermission = user_details.roles?.some((item) => item.RoleName === 'admin');

  let page = localStorage.getItem('display_page');
  if( !page ) page = 'verify';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height   : `calc(100% - 5rem)`,
      // height   : '100%',
      padding  : '1rem',
      overflow : 'auto',
      zIndex   : '0',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    // SERVER
    server_container: {
      width   : '100%' ,
      padding : 0 ,
      margin  : 0     ,
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    server_header: {
      // backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    server_details: {
      padding  : '1rem',
      margin  : '0'    ,
      width   : '100%' ,
      height  : '100%' ,
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    // USER
    user_container: {
      width: '100%',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    user_details: {
      padding : '1rem'  ,
      margin  : '0'    ,
      width   : '100%' ,
      // backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    // ROLE
    role_container: {
      width: '100%',
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    },
    role_details: {
      padding : '1px'  ,
      margin  : '0'    ,
      width   : '100%' ,
      // backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    // MODULE
    module_container: {
      width: '100%',
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    },
    module_details: {
      padding : '1px'  ,
      margin  : '0'    ,
      width   : '100%' ,
      // backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    }
  }

  const CONTAINER = {
    style: _styles.container,
  }

  // == SERVER
  const SERVER_CONTAINER = {
    sx: _styles.server_container,
    key: 1,
    variant: 'primary',
  }
  const SERVER_HEADER = {
    sx      : _styles.server_header,
    variant : 'h5',
    color   : 'primary',
    children: ['Server Details'],
  }
  const SERVER_DETAILS = {
    sx: _styles.server_details,
  }

  // == USER
  const USER_CONTAINER = {
    sx: _styles.user_container,
    key: 2,
    variant: 'primary',
  }
  const USER_HEADER = {
    variant : 'h5',
    color   : 'primary',
    children: ['User Details'],
  }
  const USER_DETAILS = {
    sx: _styles.user_details,
  }

  // == ROLE
  const ROLE_CONTAINER = {
    sx: _styles.role_container,
    key: 3,
    variant: 'primary',
  }
  const ROLE_HEADER = {
    variant : 'h5',
    color   : 'primary',
    children: ['Role Details'],
  }
  const ROLE_DETAILS = {
    sx: _styles.role_details,
  }

  // == MODULE
  const MODULE_CONTAINER = {
    sx: _styles.module_container,
    key: 4,
    variant: 'primary',
  }
  const MODULE_HEADER = {
    variant : 'h5',
    color   : 'primary',
    children: ['Module Details'],
  }
  const MODULE_DETAILS = {
    sx: _styles.module_details,
  }


  //#endregion

  //#region [green] Events

  if( user_details.roles.length === 0 ) {
    return null;
  }

  if( !hasPermission ) {
    navigate( '/' + page );    
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER } >
        <Accordion { ...SERVER_CONTAINER } >
          <AccordionSummary sx={{ background: theme.palette.background.primary[theme.palette.mode]}} expandIcon={<ExpandMoreIcon />}>
            <Typography { ...SERVER_HEADER } />
          </AccordionSummary>
          <AccordionDetails { ...SERVER_DETAILS } >
            <ServerPanel />
          </AccordionDetails>
        </Accordion>
        <Accordion { ...USER_CONTAINER } >
          <AccordionSummary sx={{ background: theme.palette.background.primary[theme.palette.mode]}} expandIcon={<ExpandMoreIcon />}>
            <Typography { ...USER_HEADER } />
          </AccordionSummary>
          <AccordionDetails { ...USER_DETAILS } >
            <UsersPanel />
          </AccordionDetails>
        </Accordion>
        <Accordion { ...ROLE_CONTAINER } >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography { ...ROLE_HEADER } />
          </AccordionSummary>
          <AccordionDetails { ...ROLE_DETAILS } >
            <RolesPanel />
          </AccordionDetails>
        </Accordion>
        <Accordion { ...MODULE_CONTAINER } >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography { ...MODULE_HEADER } />
          </AccordionSummary>
          <AccordionDetails { ...MODULE_DETAILS } >
            <ModulesPanel />
          </AccordionDetails>
        </Accordion>
      </div>
    )
  }

  //#endregion

  return display();
}
